module.exports = __webpack_public_path__ + "static/media/singsnap-logo@3x.ba6ac312.png";